// extracted by mini-css-extract-plugin
export default {"content":"BCoinMyHub_content__r2CjS","header":"BCoinMyHub_header__2fafb","tabContent":"BCoinMyHub_tabContent__UbOCF"};